module.exports = __webpack_public_path__ + "img/chevron-up.b7d6d2c1.svg";